import { postArteFinal, postArteFinalImprimible, uploadFileDigitalOcean } from '../../api/carteleriaApi';

export const createArteFinalImprimible = async (params) => {
  try {
    const { image, ...rest } = params.body;

    if (image) {
      const img = await uploadFileDigitalOcean(image, `aaffimg2/${rest.code}`);
      if (img) {
        await postArteFinalImprimible({ token: params.token, body: { ...rest, imglink: img.url } });
      }
    } else {
      await postArteFinalImprimible({ token: params.token, body: rest });
    }
  } catch (err) {
    throw new Error(err);
  }
};

export const createArteFinal = async (params) => {
  try {
    const { body, token } = params;
    const { image, ...rest } = body;

    let finalBody = { ...rest };

    if (image) {
      const img = await uploadFileDigitalOcean(image, `aaffimg2/${rest.code}`);

      if (img) {
        finalBody = {
          ...rest,
          imglink: img.url,
        };
      }
    }

    await postArteFinal({
      token,
      body: finalBody,
    });
  } catch (err) {
    throw err;
  }
};
